import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import Cookies from 'js-cookie'
const state = {
  session: {
    isLogin: Cookies.get('isLogin') || false,
    token: Cookies.get('token') || '',
    userInfo: localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')) || {}
  }
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/session/index.js